export const CleverTap = () => {};
export const REST_OF_WORLD = "REST_OF_WORLD";
export const INDIA = "INDIA";
export const PAYMENT_GATEWAY_AAA = "triplea";
export const RUPEE_ICON = "";
